/* eslint-disable max-len */
import { IRWN } from '../IRWN';
import { FSM } from './FSM';
import { ClockScene } from '../ClockScene';
import { LandingPageScene } from '../LandingPageScene';

////////////////////////////////////////////////////////////////
// In charge of loading / displaying the CLOCK Scene
////////////////////////////////////////////////////////////////
export const FSM_CLOCK = FSM.getState(FSM.stateNames.CLOCK);
FSM_CLOCK.enter = function () {
  LandingPageScene.hide();
    ClockScene.setup();
};
FSM_CLOCK.execute = function (dt) {
  ClockScene.update(dt);
};

